<template>
  <v-dialog class="dialog" v-model="dateVisible" @click:outside="close" max-width="400px">
    <v-row no-gutters style="background-color: #21343b; padding: 20px 5px 20px 20px; justify-content: space-between">
      <span class="txt-section-title">{{ $t('addDueDate') }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col>
        <!-- :class="selectedBtnType === 0 ? 'pressed_date_ex_col' : 'date_ex_col'" -->
        <div class="date_ex_col" style="cursor: pointer" @click="setPickTime(0)">
          <span class="date_ex">
            <b>{{ dateArray[0] }}</b>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- :class="selectedBtnType === 0 ? 'pressed_date_ex_col' : 'date_ex_col'" -->
        <div class="date_ex_col" style="cursor: pointer" @click="setPickTime(1)">
          <span class="date_ex">
            <b>{{ dateArray[1] }}</b>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="date_ex_col" style="cursor: pointer" @click="setPickTime(2)">
          <span class="date_ex">
            <b>{{ dateArray[2] }}</b>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="date_ex_col" style="cursor: pointer" @click="setPickTime(3)">
          <span class="date_ex">
            <b>{{ dateArray[3] }}</b>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="date_ex_col" style="cursor: pointer" @click="setPickTime(4)">
          <span class="date_ex">
            <b>{{ dateArray[4] }}</b>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="template-pick-date" align="center">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          dark
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              clearable
              v-model="pickDate"
              label="Pick a date"
              dark
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="pickDate" @input="menu = false"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
export default {
  name: 'DueDateDialog',
  props: ['dateVisible'],
  data() {
    return {
      pickDate: null,
      menu: false,
      dateArray: ['No due date', 'In 1 hour', 'In 3 hour', 'By today', 'By tomorrow'],
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    setPickTime(buttonType) {
      let selectDate = ''
      let displayDate = this.dateArray[buttonType]

      switch (buttonType) {
        // 1 hour
        case 0:
          selectDate = null
          displayDate = null
          break
        case 1:
          selectDate = this.$day().add(1, 'hour').valueOf()
          break
        // 3 hours
        case 2:
          selectDate = this.$day().add(3, 'hour').valueOf()
          break
        // By today
        case 3:
          selectDate = this.$day().set('hour', 23).set('minute', 59).set('second', 59).valueOf()
          break
        // By tomorrow
        case 4:
          selectDate = this.$day().add(1, 'd').set('hour', 23).set('minute', 59).set('second', 59).valueOf()
          break
      }

      this.$emit('setSelectDate', {
        selectedDate: selectDate,
        displayDate: displayDate,
      })
    },
    setPickDate() {
      this.$emit('setSelectDate', {
        selectedDate: this.$day(this.pickDate).set('hour', 23).set('minute', 59).set('second', 59).valueOf(),
        displayDate: this.pickDate,
      })
    },
  },
  watch: {
    pickDate() {
      this.setPickDate()
    },
  },
}
</script>

<style scoped>
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  background: #21343b !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px 20px 10px 20px;
}
.v-dialog__content >>> .row {
  margin: 0;
}
.dialog >>> .v-dialog__header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-left: 32px;
  background: #21343b !important;
}
.dialog >>> .v-dialog__title {
  color: white;
  font-weight: bold;
}
.dialog >>> .v-dialog__close {
  margin-right: 10px;
  background: #21343b !important;
}
.pressed_date_ex_col {
  border: solid;
  border-width: 1px;
  border-color: #3ed297;
  background-color: #31434f;
  padding-bottom: 12px;
  padding-top: 12px;
  border-radius: 5px !important;
}

.date_ex {
  color: white;
  padding-left: 10px;
}

.date_ex_col {
  background-color: #31434f;
  padding-bottom: 12px;
  padding-top: 12px;
  border-radius: 5px !important;
}

.btn-bottom {
  justify-content: space-between;
  margin-bottom: 6px;
}

.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}

.template-pick-date {
  border: 1px;
  border-color: #ffffff;
}
.template-pick-date >>> .v-input .v-label {
  font-size: 1em !important;
}
/* .template-pick-date >>> .v-input .v-label--active {
  font-size: 1em !important;
} */
.template-pick-date >>> .v-input input {
  margin-top: 8px;
  margin-left: 12px;
}
.template-pick-date >>> .v-input i {
  margin-top: 16px;
}
.v-menu__content {
  z-index: 206 !important;
}
</style>
